import { useState } from "react";
import { useAuth, apiError } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  const fill = (em, pw) => {
    setEmail(em);
    setPassword(pw);
  };

  return (
    <div className="min-h-screen flex" style={{ background: "var(--tm-bg)" }}>
      {/* Visual side */}
      <div className="hidden lg:block lg:w-1/2 relative">
        <img
          src="https://images.pexels.com/photos/35135510/pexels-photo-35135510.jpeg"
          alt="Tiramisu premium"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(160deg, rgba(10,10,10,.55), rgba(10,10,10,.92))" }} />
        <div className="absolute bottom-0 left-0 p-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[var(--tm-gold)] mb-3">Nador · Desserts Premium</p>
          <h1 className="font-display text-6xl tracking-tight text-[var(--tm-beige)]">TIRAMESSI</h1>
          <p className="text-[var(--tm-muted)] mt-4 max-w-sm">
            Plateforme de gestion — produits, stocks, ventes, commandes et performance en temps réel.
          </p>
        </div>
      </div>

      {/* Form side */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm tm-fade">
          <div className="lg:hidden mb-8 text-center">
            <img src="/logo.png" alt="TIRAMESSI" className="w-20 h-20 rounded-2xl object-cover mx-auto mb-3" />
            <h1 className="font-display text-4xl tracking-tight">TIRAMESSI</h1>
            <p className="text-[10px] uppercase tracking-[0.2em] text-[var(--tm-gold)] mt-1">The GOAT of tiramisu</p>
          </div>
          <div className="hidden lg:flex items-center gap-3 mb-7">
            <img src="/logo.png" alt="TIRAMESSI" className="w-14 h-14 rounded-xl object-cover" style={{ border: "1px solid var(--tm-border)" }} />
            <div>
              <h2 className="font-display text-2xl leading-none">Connexion</h2>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[var(--tm-gold)] mt-1.5">Espace de gestion</p>
            </div>
          </div>
          <h2 className="lg:hidden font-display text-2xl mb-1">Connexion</h2>
          <p className="text-[var(--tm-muted)] text-sm mb-7">Accédez à votre espace de gestion.</p>

          <form onSubmit={submit}>
            <label className="block mb-4">
              <span className="block text-xs uppercase tracking-wider text-[var(--tm-muted)] mb-1.5">Email</span>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="tm-input" placeholder="vous@tiramessi.ma" data-testid="login-email"
              />
            </label>
            <label className="block mb-5">
              <span className="block text-xs uppercase tracking-wider text-[var(--tm-muted)] mb-1.5">Mot de passe</span>
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="tm-input" placeholder="••••••••" data-testid="login-password"
              />
            </label>

            {err && (
              <div className="mb-4 text-sm px-3 py-2 rounded-lg" style={{ background: "rgba(244,67,54,.12)", color: "#F44336" }} data-testid="login-error">
                {err}
              </div>
            )}

            <button type="submit" className="tm-btn w-full" disabled={loading} data-testid="login-submit">
              {loading ? <Loader2 size={16} className="tm-spin" /> : "Se connecter"}
            </button>
          </form>

          <div className="mt-7 pt-5" style={{ borderTop: "1px solid var(--tm-border)" }}>
            <p className="text-xs text-[var(--tm-muted)] mb-2">Comptes de démonstration :</p>
            <div className="flex gap-2">
              <button onClick={() => fill("admin@tiramessi.ma", "Admin2025!")} className="tm-btn-ghost tm-btn text-xs flex-1" data-testid="demo-admin">
                Admin
              </button>
              <button onClick={() => fill("employe@tiramessi.ma", "Employe2025!")} className="tm-btn-ghost tm-btn text-xs flex-1" data-testid="demo-employe">
                Employé
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
